import * as React from 'react';
import Chip from '@mui/material/Chip';
import CustomTooltip from '../../common/components/CustomTooltip';

export interface IRolesAutocompleteProps {
  label: string;
  tooltipTitle: string;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
}

const StatusChip: React.FC<
  React.PropsWithChildren<IRolesAutocompleteProps>
> = ({ tooltipTitle, label, color }) => {
  return (
    <CustomTooltip title={tooltipTitle}>
      <Chip
        label={label}
        size='small'
        variant='outlined'
        color={color || 'default'}
      />
    </CustomTooltip>
  );
};

export default StatusChip;
